import { checkInvoiceWithRetry, PAYMENT_SCOPE_PERSONAL_ACCOUNT, takePendingPayment } from './index'

/**
 * @param {object} api плагин $api
 * @param {object} store хранилище личного кабинета
 * @returns {Promise<{paid: boolean, message: string}|null>} null — клиент пришёл не с оплаты
 */
export async function handlePendingPaymentReturn(api, store) {
    const pending = takePendingPayment(PAYMENT_SCOPE_PERSONAL_ACCOUNT)
    if (!pending) {
        return null
    }

    let paid = false
    try {
        paid = Boolean(await checkInvoiceWithRetry(api, pending.invoiceId, 1))
    } catch (error) {
        console.log('failed to check invoice after payment return', error)
    }

    if (!paid) {
        return { paid: false, message: 'Оплата не прошла. Попробуйте ещё раз.' }
    }

    store.dispatch('loadUser')

    if (pending.shop) {
        await finishShopPurchase(api, store, pending.shop)

        return { paid: true, message: '' }
    }

    return { paid: true, message: pending.message || 'Оплата прошла успешно' }
}

async function finishShopPurchase(api, store, shop) {
    store.commit('SET_SHOP_SUCCESS_MODAL', {
        name: shop.name,
        price: shop.price,
        method: shop.method,
    })
    store.dispatch(shop.itemType === 'contract' ? 'loadContracts' : 'loadServices')

    if (!shop.scheduleId || !shop.purchasedItemId) {
        return
    }

    const params = shop.itemType === 'contract'
        ? { client_contract_id: shop.purchasedItemId }
        : { client_service_id: shop.purchasedItemId }

    try {
        const response = await api.schedule.postRegistration(shop.scheduleId, params)
        store.commit('SET_SCHEDULE_REGISTRATION_RESULT', {
            scheduleId: shop.scheduleId,
            success: true,
            message: response.data?.status === 'waiting' ? 'Вы добавлены в лист ожидания!' : 'Вы записаны!',
        })
    } catch (error) {
        store.commit('SET_SCHEDULE_REGISTRATION_RESULT', {
            scheduleId: shop.scheduleId,
            success: false,
            message: 'Покупка прошла успешно, но запись не удалась. Повторите попытку записи',
        })
    }
}
